import { render, staticRenderFns } from "./BottomButtonWithText.vue?vue&type=template&id=64bd6b58&"
import script from "./BottomButtonWithText.vue?vue&type=script&lang=js&"
export * from "./BottomButtonWithText.vue?vue&type=script&lang=js&"
import style0 from "./BottomButtonWithText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/travis/build/georgesoteriou/flip/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
